export default (status) => {
    const _maps = {
        completed: 'Đã hoàn thành',
        uncompleted: 'Chưa hoàn thành',
        released: 'Đã giải phóng'
    }

    return _maps[status] || status
}
